var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Radar',{attrs:{"chart-options":_vm.chartOptions,"chart-data":_vm.chartData,"styles":_vm.styles,"width":_vm.width,"height":_vm.height}})}
var staticRenderFns = []

export { render, staticRenderFns }